/* Atelier Alpino: the storefront alerts (owner, 05/10; docs/atelier-alpino-theme-port.md, "Storefront alerts").
   One controller for the e-mail signups of the theme: on the product page the bell next to the price ("Avvisami se
   scende di prezzo", a sale included) and "Avvisami in qualsiasi colore" in the back-in-stock
   popup of a sold-out size (assets/luxe.js), on a collection "Avvisami quando arriva la mia taglia", on a brand
   page "Segui il brand", under a route article "Ricevi la traccia GPX via email", on the rental page "Ricevi il
   preventivo via email".
   Each call to action is rendered in Liquid inside a [data-luxe-alert] wrapper, its button opening the section's one
   <x-modal> (snippets/luxe-alert-modal.liquid) through Prestige's aria-controls, so the theme's focus trap, Esc and
   overlay apply. Here the dialog is filled for that call to action just before it opens, and its request is posted as
   text/plain JSON (no preflight), as assets/bis-mini.js does, to the back-in-stock app.
   The consent notice under the button is the app's (GET /api/public/alerts/notices, asked when a call to action is
   pointed at or focused, kept for the page): the alert and Fabbrica Ski Sises e-mail marketing are accepted together
   with that one text, sent back with its version exactly as the shopper read it. Without it (the app not answering,
   or not deployed yet) the dialog says the service is not active yet and posts nothing. */


  function mountWhatsAppCollection(root, purpose, options) {
    if (!root) return;
    var api = String(options.apiBase).replace(/\/$/, '');
    var ready = window.SkiSisesWhatsAppCollection ? Promise.resolve() : window.__sksWaCollectionScript;
    if (!ready) ready = window.__sksWaCollectionScript = new Promise(function (resolve, reject) {
      var script = document.createElement('script'); script.src = api + '/whatsapp-collection-v2.js?v=20261020-1';
      script.onload = resolve; script.onerror = function () { window.__sksWaCollectionScript = null; reject(new Error('unavailable')); }; document.head.append(script);
    });
    ready.then(function () { return window.SkiSisesWhatsAppCollection?.mount(root, Object.assign({ purpose: purpose }, options)); }).catch(function () {});
  }

const DEFAULT_API = 'https://ski-sises-back-in-stock.onrender.com';
const LANGUAGES = ['it', 'en', 'de', 'es', 'fr', 'el', 'nl', 'pt', 'sv'];
const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const RETRY_AFTER = 30000;
// the calls to action (data-luxe-alert) and the app's notice for each
const NOTICE = { price_drop: 'price_drop', on_sale: 'on_sale', size: 'size_model', size_collection: 'size_collection', brand_follow: 'brand_follow', rental_quote: 'rental_quote', area_guide: 'area_guide' };
const ENDPOINT = { rental_quote: 'rental-quote', area_guide: 'area-guide' };

const apiBase = () => String(window.SkiSisesBisConfig?.apiBase || DEFAULT_API).replace(/\/$/, '');
const language = () => {
  const tag = String(document.documentElement.lang || window.Shopify?.locale || 'it').toLowerCase().split(/[-_]/)[0];
  return LANGUAGES.includes(tag) ? tag : 'it';
};
const shopDomain = () => window.Shopify?.shop || location.hostname;

/* ---------- the app's notices: one request for the page, asked again only after a pause when it failed ---------- */
let notices = null;
let noticeState = 'idle'; // idle | loading | ready | failed
let noticeRequest = null;
let failedAt = 0;
const loadNotices = (force = false) => {
  if (notices) return Promise.resolve(notices);
  if (noticeRequest) return noticeRequest;
  if (!force && Date.now() - failedAt < RETRY_AFTER) return Promise.resolve(null);
  noticeState = 'loading';
  const query = new URLSearchParams({ shop: shopDomain(), locale: language() });
  noticeRequest = fetch(`${apiBase()}/api/public/alerts/notices?${query}`, { headers: { Accept: 'application/json' }, credentials: 'omit' })
    .then((response) => (response.ok ? response.json() : null))
    .then((answer) => (answer && answer.notices && typeof answer.notices === 'object' ? answer.notices : null))
    .catch(() => null)
    .then((list) => {
      noticeRequest = null;
      notices = list;
      noticeState = list ? 'ready' : 'failed';
      if (!list) failedAt = Date.now();
      return list;
    });
  return noticeRequest;
};
const noticeFor = (key) => {
  const notice = notices?.[key];
  const text = typeof notice?.text === 'string' ? notice.text.trim() : '';
  const version = notice?.version;
  return text && version != null && String(version).trim() ? { text, version } : null;
};
// the app fills {shop}; the brand and the size are the theme's, sent back with the text in noticeVars
const fill = (text, vars) => String(text || '').replace(/\{(brand|size)\}/g, (match, key) => (vars[key] ? vars[key] : match));
const unfilled = (text) => /\{(brand|size)\}/.test(text);

/* ---------- words: plain text, the brand's name never translated ---------- */
const write = (element, template, vars = {}) => {
  element.replaceChildren();
  String(template || '').split(/(\{brand\}|\{size\})/).forEach((part) => {
    if (part === '{brand}' && vars.brand) {
      const name = document.createElement('span');
      name.setAttribute('translate', 'no');
      name.textContent = vars.brand;
      element.append(name);
    } else if (part === '{size}' && vars.size) {
      element.append(vars.size);
    } else if (part) {
      element.append(part);
    }
  });
};
const money = (amount) => {
  try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: 'EUR' }).format(amount); } catch { return `${amount} €`; }
};

/* ---------- sizes: the model's, in their order ---------- */
const LETTERS = ['XXXS', '3XS', 'XXS', '2XS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL'];
const sizeNumber = (label) => {
  const match = String(label).trim().match(/^(\d+)(?:[.,](\d+))?(?:\s+(\d)\/(\d))?/);
  if (!match) return NaN;
  return parseFloat(`${match[1]}.${match[2] || 0}`) + (match[3] ? Number(match[3]) / Number(match[4]) : 0);
};
const sortSizes = (labels) => {
  const upper = (label) => String(label).trim().toUpperCase();
  if (labels.every((label) => LETTERS.includes(upper(label)))) return [...labels].sort((a, b) => LETTERS.indexOf(upper(a)) - LETTERS.indexOf(upper(b)));
  if (labels.every((label) => Number.isFinite(sizeNumber(label)))) return [...labels].sort((a, b) => sizeNumber(a) - sizeNumber(b));
  return labels;
};
// the page's sizes ([label, variant id, available] for each variant) and the colourways' ([url, title, [[label,
// available]]]): each size the shopper cannot buy in this colour, sold out here (its variant) or missing here, with the
// first colourway that has it in stock
const sizeRows = (data) => {
  const rows = new Map();
  const row = (label) => {
    const key = String(label);
    if (!rows.has(key)) rows.set(key, { label: key, here: 'missing', variant: '', elsewhere: null });
    return rows.get(key);
  };
  (Array.isArray(data.here) ? data.here : []).forEach(([label, variant, available]) => {
    const entry = row(label);
    if (available) entry.here = 'available';
    else if (entry.here !== 'available') { entry.here = 'soldout'; entry.variant ||= String(variant); }
  });
  (Array.isArray(data.family) ? data.family : []).forEach(([url, title, sizes]) => {
    (Array.isArray(sizes) ? sizes : []).forEach(([label, available]) => {
      const entry = row(label);
      if (available && !entry.elsewhere && url) entry.elsewhere = { url: String(url), title: String(title || '') };
    });
  });
  return sortSizes([...rows.keys()]).map((label) => rows.get(label)).filter((entry) => entry.here !== 'available');
};
const pageSizes = (data) => [...new Set((Array.isArray(data.here) ? data.here : []).map(([label]) => String(label)))];
// the size the shopper picked on the page: only from the address (?variant=), which the picker writes on a choice
const pickedSize = (data) => {
  const id = new URLSearchParams(location.search).get('variant');
  const variant = id && (Array.isArray(data.here) ? data.here : []).find((entry) => String(entry[1]) === id);
  return variant ? String(variant[0]) : '';
};

/* ---------- the dialog ---------- */
const parts = new WeakMap();
const states = new WeakMap();
const ui = (modal) => {
  if (parts.has(modal)) return parts.get(modal);
  const find = (selector) => modal.querySelector(selector);
  let words = {};
  try { words = JSON.parse(find('script[data-luxe-alert-i18n]')?.textContent || '{}') || {}; } catch { words = {}; }
  const found = {
    words,
    title: find('[slot="header"]'),
    form: find('[data-luxe-alert-form]'),
    lead: find('[data-luxe-alert-lead]'),
    sizes: find('[data-luxe-alert-sizes]'),
    sizeList: find('[data-luxe-alert-size-list]'),
    sizeField: find('[data-luxe-alert-size-field]'),
    select: find('[data-luxe-alert-select]'),
    scope: find('[data-luxe-alert-scope]'),
    hint: find('[data-luxe-alert-hint]'),
    summary: find('[data-luxe-alert-summary]'),
    emailField: find('[data-luxe-alert-email-field]'),
    email: find('input[type="email"]'),
    submit: find('[data-luxe-alert-submit]'),
    notice: find('[data-luxe-alert-notice]'),
    status: find('[data-luxe-alert-status]'),
    done: find('[data-luxe-alert-done]'),
    doneText: find('[data-luxe-alert-done-text]'),
    whatsapp: find('[data-wa-collection-host]'),
    close: find('[data-luxe-alert-close]'),
    said: '',
    timer: 0
  };
  parts.set(modal, found);
  return found;
};
const complete = (modal) => {
  const p = ui(modal);
  return Boolean(p.title && p.form && p.lead && p.sizes && p.sizeList && p.sizeField && p.select && p.scope && p.hint && p.summary && p.emailField && p.email && p.submit && p.notice && p.status && p.done && p.doneText);
};

// one message at a time in the live region, written a moment after it is emptied so it is read again
const say = (p, key, tone = 'info') => {
  clearTimeout(p.timer);
  p.said = key || '';
  p.status.textContent = '';
  p.status.dataset.tone = tone;
  if (!key) return;
  const [group, name] = key.split('.');
  const text = p.words[group]?.[name] || '';
  p.timer = setTimeout(() => { p.status.textContent = text; }, 60);
};

const radio = (name, value, label) => {
  const wrap = document.createElement('label');
  wrap.className = 'luxe-alert__size';
  const input = document.createElement('input');
  input.type = 'radio';
  input.name = name;
  input.value = value;
  const text = document.createElement('span');
  text.textContent = label;
  wrap.append(input, text);
  return wrap;
};
const options = (select, labels, placeholder, chosen) => {
  select.replaceChildren();
  if (placeholder) {
    const empty = new Option(placeholder.text, '');
    empty.disabled = Boolean(placeholder.disabled);
    select.append(empty);
  }
  labels.forEach((label) => select.append(new Option(label, label)));
  select.value = labels.includes(chosen) ? chosen : '';
};

const varsOf = (state) => {
  const vars = {};
  const brand = state.data.vendor || '';
  if (brand && ['price_drop', 'on_sale', 'size', 'brand_follow'].includes(state.kind)) vars.brand = String(brand);
  if (state.size) vars.size = state.size;
  return vars;
};
// the form asks for the e-mail; for the model's size only once "In qualsiasi colore" is chosen ("In questo colore" goes
// on to the back-in-stock popup, which asks for it)
const asksEmail = (state) => state.kind !== 'size' || state.scope === 'any';

const refresh = (modal) => {
  const state = states.get(modal);
  if (!state) return;
  const p = ui(modal);
  const w = p.words;
  if (p.whatsapp) { p.whatsapp.hidden = !asksEmail(state); window.SkiSisesWhatsAppCollection?.refresh?.(p.whatsapp); }
  if (state.kind === 'size') {
    const row = state.rows.find((entry) => entry.label === state.size);
    const here = p.scope.querySelector('input[value="here"]');
    const any = p.scope.querySelector('input[value="any"]');
    here.disabled = !row || row.here !== 'soldout';
    any.disabled = !row || Boolean(row.elsewhere);
    if (row && (!state.scope || (state.scope === 'here' && here.disabled) || (state.scope === 'any' && any.disabled))) {
      state.scope = !here.disabled ? 'here' : !any.disabled ? 'any' : '';
    }
    here.checked = state.scope === 'here';
    any.checked = state.scope === 'any';
    p.scope.hidden = !row;
    p.hint.replaceChildren();
    if (row?.elsewhere) {
      p.hint.append(fill(w.size?.elsewhere, { size: row.label }), ' ');
      const link = document.createElement('a');
      link.href = row.elsewhere.url;
      link.textContent = row.elsewhere.title || row.elsewhere.url;
      p.hint.append(link);
    } else if (row?.here === 'missing') {
      p.hint.append(fill(w.size?.missing_here, { size: row.label }));
    }
    p.hint.hidden = !p.hint.childNodes.length;
    p.submit.disabled = state.sending || Boolean(row && !state.scope);
  }
  const asks = asksEmail(state);
  p.emailField.hidden = !asks;
  const notice = asks ? noticeFor(NOTICE[state.kind]) : null;
  const text = notice ? fill(notice.text, varsOf(state)) : '';
  // a notice that names the size waits for it
  p.notice.textContent = unfilled(text) ? '' : text;
  p.notice.hidden = !p.notice.textContent;
  // no notice once the app has answered (or failed to): the service is not active yet
  if (asks && !notice && noticeState !== 'loading' && noticeState !== 'idle') {
    if (p.said !== 'modal.unavailable') say(p, 'modal.unavailable', 'info');
  } else if (p.said === 'modal.unavailable') {
    say(p, '');
  }
  if (!state.sending) {
    p.submit.textContent = state.kind === 'size' && state.scope === 'here' ? w.size?.continue : (w[state.kind]?.submit || w.modal?.submit || '');
  }
};

// the call to action that opens the dialog: its kind and data, the form back to its start
const configure = (modal, cta) => {
  const kind = cta.dataset.luxeAlert;
  if (!NOTICE[kind] || !complete(modal)) return;
  const p = ui(modal);
  const w = p.words;
  if (p.whatsapp) {
    const root = document.createElement('div'); root.setAttribute('data-wa-collection-host', ''); p.whatsapp.replaceWith(root); p.whatsapp = root;
    p.done.querySelector('[data-wa-collection-result]')?.remove();
    p.form.querySelectorAll('[data-wa-collection-notice]').forEach((n) => n.remove());
    mountWhatsAppCollection(root, NOTICE[kind], {apiBase: apiBase(), shop: shopDomain(), locale: language(), noticeAfter: p.notice});
  }
  let data = {};
  const source = cta.dataset.luxeAlertSource ? document.getElementById(cta.dataset.luxeAlertSource) : cta.querySelector('script[data-luxe-alert-data]');
  try { data = JSON.parse(source?.textContent || '{}') || {}; } catch { data = {}; }
  const state = { kind, data, size: '', scope: '', rows: [], sending: false };
  states.set(modal, state);
  bind(modal); // a dialog drawn after the page loaded (Prestige redraws a collection for each filter)
  p.form.hidden = false;
  p.done.hidden = true;
  p.doneText.textContent = '';
  say(p, '');
  [p.sizes, p.sizeField, p.scope, p.hint, p.summary].forEach((element) => { element.hidden = true; });
  p.sizeList.replaceChildren();
  p.select.replaceChildren();
  p.email.removeAttribute('aria-invalid');
  p.submit.disabled = false;
  p.submit.removeAttribute('aria-busy');
  const vars = varsOf(state);
  write(p.title, w[kind]?.title, vars);
  write(p.lead, w[kind]?.lead, vars);
  if (kind === 'price_drop' || kind === 'on_sale') {
    // the size is optional: "Tutte le taglie", or the size picked on the page
    const labels = pageSizes(data);
    if (labels.length > 1) {
      state.size = pickedSize(data);
      options(p.select, labels, { text: w.modal?.any_size || '' }, state.size);
      p.sizeField.hidden = false;
    }
  } else if (kind === 'size') {
    state.rows = sizeRows(data);
    const name = `${modal.id}-size`;
    p.sizeList.replaceChildren(...state.rows.map((row) => radio(name, row.label, row.label)));
    p.sizes.hidden = !state.rows.length;
    // a size and a scope given by the call to action (the back-in-stock popup's "Avvisami in qualsiasi colore")
    const picked = cta.dataset.luxeAlertSize || pickedSize(data);
    if (state.rows.length === 1) state.size = state.rows[0].label;
    else if (state.rows.some((row) => row.label === picked)) state.size = picked;
    if (cta.dataset.luxeAlertScope === 'any' || cta.dataset.luxeAlertScope === 'here') state.scope = cta.dataset.luxeAlertScope;
    const chosen = [...p.sizeList.querySelectorAll('input')].find((input) => input.value === state.size);
    if (chosen) chosen.checked = true;
  } else if (kind === 'size_collection') {
    const labels = Array.isArray(data.sizes) ? data.sizes.map(String) : [];
    state.size = labels.includes(String(data.size || '')) ? String(data.size) : '';
    options(p.select, labels, state.size ? null : { text: w.modal?.choose_size || '', disabled: true }, state.size);
    p.sizeField.hidden = !labels.length;
  } else if (kind === 'rental_quote') {
    const quote = rentalQuote();
    if (quote) {
      const template = quote.items.length === 1 ? w.rental_quote?.summary_one : w.rental_quote?.summary_other;
      p.summary.textContent = String(template || '').replace('{count}', String(quote.items.length)).replace('{total}', money(quote.total));
      p.summary.hidden = false;
    }
  }
  refresh(modal);
  if (noticeState !== 'ready') loadNotices().then(() => refresh(modal));
};

/* ---------- sending ---------- */
// the rental page's quote as it computed it (sections/noleggio-simulatore-preventivo.liquid), with what was chosen
// on each line: the app prices those lines again from the same price list (docs/rental-tariffs.md)
const rentalQuote = () => {
  const quote = window.SkiSisesRentalQuote;
  const items = (Array.isArray(quote?.items) ? quote.items : [])
    .filter((item) => item && item.title)
    .map((item) => {
      const line = { title: String(item.title), sub: String(item.sub || ''), total: Number(item.total) || 0 };
      if (typeof item.handle !== 'string' || !item.handle) return line;
      return { ...line, handle: item.handle, mode: String(item.mode || 'day'), days: Number(item.days) || 1,
        season: Number(item.season) || 0, qty: Number(item.qty) || 1 };
    });
  if (!items.length) return null;
  const total = Number.isFinite(Number(quote.total)) ? Number(quote.total) : items.reduce((sum, item) => sum + item.total, 0);
  return { items, total, pickupDate: /^\d{4}-\d{2}-\d{2}$/.test(String(quote.pickupDate || '')) ? quote.pickupDate : null };
};
const payload = (state, quote) => {
  const data = state.data;
  switch (state.kind) {
    case 'price_drop':
    case 'on_sale': {
      const target = { productId: String(data.productId || ''), handle: String(data.handle || ''), title: String(data.title || '') };
      if (state.size) {
        const variant = (Array.isArray(data.here) ? data.here : []).find((entry) => String(entry[0]) === state.size);
        if (variant) target.variantId = String(variant[1]);
        target.size = state.size;
      }
      return { kind: state.kind, target };
    }
    case 'size':
      // the model's key and attribute as the back-in-stock app embed sends them, so the server finds every colourway
      return { kind: 'size_model', target: { productId: String(data.productId || ''), handle: String(data.handle || ''), title: String(data.title || ''), size: state.size }, productTypeAttribute: 'custom.aaa', productTypeValue: String(data.productTypeValue || '') };
    case 'size_collection':
      return { kind: 'size_collection', target: { collectionId: String(data.collectionId || ''), handle: String(data.handle || ''), title: String(data.title || ''), size: state.size } };
    case 'brand_follow':
      return { kind: 'brand_follow', target: { vendor: String(data.vendor || ''), collectionHandle: String(data.collectionHandle || '') } };
    case 'rental_quote':
      return { items: quote.items, total: quote.total, pickupDate: quote.pickupDate };
    case 'area_guide':
      return data.topicId ? { articleId: String(data.articleId || ''), topicId: String(data.topicId) } : { articleId: String(data.articleId || '') };
    default:
      return {};
  }
};
const busy = (modal, on) => {
  const state = states.get(modal);
  const p = ui(modal);
  state.sending = on;
  p.submit.disabled = on;
  if (on) {
    p.submit.setAttribute('aria-busy', 'true');
    p.submit.textContent = p.words.modal?.sending || '';
  } else {
    p.submit.removeAttribute('aria-busy');
    refresh(modal);
  }
};
const finish = (modal) => {
  const state = states.get(modal);
  const p = ui(modal);
  state.sending = false;
  p.form.hidden = true;
  p.done.hidden = false;
  p.doneText.textContent = '';
  setTimeout(() => write(p.doneText, p.words[state.kind]?.done, varsOf(state)), 60);
  (p.close || p.title).focus({ preventScroll: true });
};

// "In questo colore": the back-in-stock popup the product page already has, for that size (assets/luxe.js opens the
// app's own; without it, the theme's assets/bis-mini.js), once this dialog has closed
let bisMiniLoading = null;
const bisMini = (src) => {
  if (window.SkiSisesBisMini) return Promise.resolve(window.SkiSisesBisMini);
  if (!src) return Promise.resolve(null);
  bisMiniLoading ||= new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve(window.SkiSisesBisMini || null);
    script.onerror = () => resolve(null);
    document.head.append(script);
  }).then((api) => { if (!api) bisMiniLoading = null; return api; });
  return bisMiniLoading;
};
const handOver = (modal, state) => {
  const row = state.rows.find((entry) => entry.label === state.size);
  if (!row?.variant) return;
  const data = state.data;
  const opened = typeof modal.hide === 'function' ? modal.hide() : Promise.resolve();
  opened.then(() => {
    const ask = new CustomEvent('luxe:back-in-stock', { cancelable: true, detail: { variantId: row.variant } });
    if (!document.dispatchEvent(ask)) return;
    bisMini(data.bisSrc).then((api) => {
      if (api) {
        api.open({ productId: data.productId, productHandle: data.handle, productTitle: data.title, productVendor: data.vendor, productImage: data.image, variantId: row.variant, variantTitle: row.label, language: language() });
      } else {
        location.href = `${data.url || location.pathname}?variant=${encodeURIComponent(row.variant)}`;
      }
    });
  });
};

const submit = async (modal) => {
  const state = states.get(modal);
  if (!state || state.sending) return;
  const p = ui(modal);
  // the notice recorded is the one on screen when the button is pressed: one that arrives only after the press is
  // shown first, and sent on the next press
  const shown = p.notice.textContent;
  if ((state.kind === 'size' || state.kind === 'size_collection') && !state.size) {
    say(p, 'modal.missing_size', 'error');
    (p.sizeList.querySelector('input') || p.select).focus();
    return;
  }
  if (state.kind === 'size' && state.scope === 'here') { handOver(modal, state); return; }
  if (state.kind === 'size' && state.scope !== 'any') return;
  let quote = null;
  if (state.kind === 'rental_quote') {
    quote = rentalQuote();
    if (!quote) { say(p, 'rental_quote.empty', 'error'); return; }
  }
  const email = p.email.value.trim();
  if (!EMAIL.test(email)) {
    p.email.setAttribute('aria-invalid', 'true');
    say(p, 'modal.invalid_email', 'error');
    p.email.focus();
    return;
  }
  p.email.removeAttribute('aria-invalid');
  busy(modal, true);
  if (!notices) await loadNotices(true);
  const notice = noticeFor(NOTICE[state.kind]);
  const vars = varsOf(state);
  const text = notice ? fill(notice.text, vars) : '';
  busy(modal, false);
  if (!notice) { say(p, 'modal.unavailable', 'info'); return; }
  if (unfilled(text)) {
    say(p, 'modal.missing_size', 'error');
    (p.sizeField.hidden ? p.email : p.select).focus();
    return;
  }
  if (shown !== text) return;
  busy(modal, true);
  say(p, '');
  const body = {
    shop: shopDomain(),
    locale: language(),
    email,
    company: '',
    sourceUrl: location.href,
    whatsappCollection: window.SkiSisesWhatsAppCollection?.value(p.whatsapp) || null,
    consentText: text,
    consentVersion: notice.version,
    marketingConsent: true,
    marketingConsentText: text,
    marketingConsentVersion: notice.version,
    noticeVars: vars,
    ...payload(state, quote)
  };
  let status = 0;
  let answer = null;
  try {
    const response = await fetch(`${apiBase()}/api/public/alerts/${ENDPOINT[state.kind] || 'subscribe'}`, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body), credentials: 'omit' });
    status = response.status;
    answer = await response.json().catch(() => null);
  } catch { status = 0; }
  if (states.get(modal) !== state) return; // the dialog was opened again for another call to action
  if (status >= 200 && status < 300 && answer?.ok) {
    window.SkiSisesAdsIntent?.track(state.kind, {
      brand: state.data.vendor,
      collection_handle: state.data.collectionHandle || (state.kind === 'size_collection' ? state.data.handle : ''),
      product_id: state.data.productId
    });
    finish(modal);
    // the WhatsApp step goes above "Chiudi"
    window.SkiSisesWhatsAppCollection?.result(p.done, answer.whatsappCollection, p.close?.closest('dialog-close-button') || p.close);
    return;
  }
  busy(modal, false);
  const error = answer?.error;
  if (error === 'invalid_email') {
    p.email.setAttribute('aria-invalid', 'true');
    say(p, 'modal.invalid_email', 'error');
  } else if (status === 429 || error === 'rate_limited') {
    say(p, 'modal.rate_limited', 'error');
  } else if (error === 'guide_unavailable') {
    say(p, 'area_guide.unavailable', 'error');
  } else {
    say(p, 'modal.error', 'error');
  }
};

/* ---------- wiring: each dialog once; focus inside it when it opens ---------- */
const bound = new WeakSet();
const bind = (modal) => {
  if (bound.has(modal) || !complete(modal)) return;
  bound.add(modal);
  const p = ui(modal);
  p.form.addEventListener('submit', (event) => {
    event.preventDefault();
    submit(modal);
  });
  p.form.addEventListener('change', (event) => {
    const state = states.get(modal);
    const target = event.target;
    if (!state) return;
    if (target === p.select || target.name === `${modal.id}-size`) state.size = target.value;
    else if (target.name === `${modal.id}-scope`) state.scope = target.value;
    else return;
    if (p.said && p.said !== 'modal.unavailable') say(p, '');
    refresh(modal);
  });
  p.email.addEventListener('input', () => {
    if (p.email.hasAttribute('aria-invalid')) {
      p.email.removeAttribute('aria-invalid');
      if (p.said === 'modal.invalid_email') say(p, '');
    }
  });
  // Prestige's trap focuses nothing (initial-focus="false"): the first field with a mouse, the title on a touch screen,
  // so the phone's keyboard does not cover the dialog as it opens
  modal.addEventListener('dialog:after-show', () => {
    if (modal.contains(document.activeElement) && document.activeElement !== modal) return;
    const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
    const visible = (element) => element && !element.disabled && !element.closest('[hidden]');
    const first = fine ? [p.sizeList.querySelector('input:checked'), p.sizeList.querySelector('input'), p.select, p.email, p.submit].find(visible) : null;
    (first || p.title).focus({ preventScroll: true });
  });
};

// the click reaches this listener before Prestige's own on the body, which then opens the dialog
document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-luxe-alert] [aria-controls]');
  if (!button) return;
  const modal = document.getElementById(button.getAttribute('aria-controls'));
  if (modal?.matches('[data-luxe-alert-modal]')) configure(modal, button.closest('[data-luxe-alert]'));
}, true);
// the notices are asked as soon as a call to action is pointed at or reached with the keyboard
const warm = (event) => { if (event.target.closest?.('[data-luxe-alert]')) loadNotices(); };
document.addEventListener('pointerover', warm, { passive: true });
document.addEventListener('focusin', warm);
// a dialog opened before this script ran (its call to action pressed while the page was loading)
document.querySelectorAll('[data-luxe-alert-modal]').forEach((modal) => {
  bind(modal);
  if (!modal.hasAttribute('open') || states.has(modal)) return;
  const cta = document.activeElement?.closest?.('[data-luxe-alert]') || document.querySelector(`[data-luxe-alert] [aria-controls="${CSS.escape(modal.id)}"]`)?.closest('[data-luxe-alert]');
  if (cta) configure(modal, cta);
});
